import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import type { IAppointmentDataType } from "@api/appointmentData";
import { useUIStore } from "@/stores/uiStore";

export const healthRecordRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.list.route,
      lazy: () =>
        import("@pages/panelPages/healthRecord/healthRecordTablePage"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.forp", [], "index", "main");
        return {};
      },
    },
    permissions: ["patient", "staff"],
  },
  {
    route: {
      path: path.experiments.route,
      lazy: () => import("@pages/panelPages/healthRecord/experimentsTablePage"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.MedicalOrders.experiments",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["patient", "staff"],
  },
  {
    route: {
      path: path.followup.route,
      lazy: () => import("@pages/panelPages/healthRecord/followUpTablePage"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.MedicalOrders.followup",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["patient", "staff"],
  },
  {
    route: {
      path: path.images.route,
      lazy: () => import("@pages/panelPages/healthRecord/imagesTablePage"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.MedicalOrders.imaging",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["patient", "staff"],
  },
  {
    route: {
      path: path.orders.route,
      lazy: () => import("@pages/panelPages/healthRecord/ordersTablePage"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.MedicalOrders.orders",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["patient", "staff"],
  },
  {
    route: {
      path: path.prescription.route,
      lazy: () =>
        import("@pages/panelPages/healthRecord/prescriptionTablePage"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.MedicalOrders.prescription",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["patient", "staff"],
  },
  {
    route: {
      path: path.referral.route,
      lazy: () => import("@pages/panelPages/healthRecord/referralTAblePage"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.MedicalOrders.referrals",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["patient", "staff"],
  },

  {
    route: {
      path: path.view.route,
      lazy: () => import("@pages/panelPages/healthRecord/showHealthRecordPage"),
      loader: ({ request, params }) => {
        const type: IAppointmentDataType = params?.type as IAppointmentDataType;

        useUIStore
          .getState()
          .setPage(
            request,
            `pageTitle.show_${type}`,
            [{ title: "pageTitle.forp", url: path.list.link() }],
            "index",
          );
        return {};
      },
    },
    permissions: ["patient", "staff"],
  },
];
